var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 26,
    viewBox: "0 0 14 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2486 0.00772444L9.28058 1.18184C9.11661 1.24364 8.98544 1.39813 8.98544 1.55262V9.52425C8.98544 9.67874 8.85426 9.83323 8.6903 9.89503L4.78786 11.0691C4.62389 11.1309 4.49272 11.0382 4.49272 10.8838V2.88122C4.49272 2.72673 4.36155 2.63404 4.19758 2.69583L0.295142 3.86995C0.131174 3.93175 0 4.08624 0 4.24073V25.4675C0 25.622 0.131174 25.7147 0.295142 25.6529L4.26316 24.4788C4.42713 24.417 4.55831 24.2625 4.55831 24.108V16.0746C4.55831 15.9201 4.68948 15.7656 4.85345 15.7038L8.75588 14.5297C8.91985 14.4679 9.05103 14.5606 9.05103 14.7151V22.7485C9.05103 22.903 9.1822 22.9957 9.34617 22.9339L13.3142 21.7598C13.4782 21.698 13.6093 21.5435 13.6093 21.389V0.193111C13.5437 0.0386224 13.4126 -0.0231734 13.2486 0.00772444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHNew);
export default __webpack_public_path__ + "static/media/H-new.63facf27fa6edae395a8fad702538702.svg";
export { ForwardRef as ReactComponent };